(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var overlay = drawer.querySelector('[data-cart-drawer-overlay]');
  var panel = drawer.querySelector('[data-cart-drawer-panel]');
  var itemsWrap = drawer.querySelector('[data-cart-drawer-items]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var subtotalOriginalEl = drawer.querySelector('[data-cart-subtotal-original]');
  var subtotalSavingsEl = drawer.querySelector('[data-cart-subtotal-savings]');
  var subtotalSavingsAmountEl = drawer.querySelector('[data-cart-subtotal-savings-amount]');
  var checkoutLink = drawer.querySelector('[data-cart-checkout-link]');
  var continueShoppingBtn = drawer.querySelector('[data-cart-continue-shopping]');
  var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
  var livePoliteEl = drawer.querySelector('[data-cart-live-polite]');
  var liveAssertiveEl = drawer.querySelector('[data-cart-live-assertive]');
  var strings = window.cartStrings || {
    remove: 'Remove',
    empty: 'Your cart is empty',
    youSave: 'You Save',
    quantityUpdated: 'Quantity updated. Subtotal: %SUBTOTAL%',
    itemRemoved: 'Item removed. Subtotal: %SUBTOTAL%',
    errorGeneric: 'Something went wrong. Please try again.',
    quantity: 'Quantity',
    decreaseQuantity: 'Decrease quantity',
    increaseQuantity: 'Increase quantity'
  };
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Base unit-step for any grouped cart line (currently only Travel Wet
  // Wipes). Matches the smallest tier size in extensions/wet-wipes-pack-
  // pricing's TIERS and the "must be a multiple of 3" rule in
  // extensions/wet-wipes-pack-validation. There is no metafield access
  // from the cart drawer to derive this per-product, so if a second
  // grouped product ever ships with a different base tier size this
  // constant needs to become per-product.
  var PACK_STEP = 3;
  // Any cart line whose product carries this tag is grouped into one
  // customer-facing row (see groupCartItems/isGroupedItem below), regardless
  // of which underlying variant/design it is. Purely theme-side presentation
  // - no Shopify Function involved, no prices/variants/inventory touched.
  var GROUPED_PRODUCT_TAG = 'travel-wet-wipes-grouped';
  var GROUPED_DISPLAY_TITLE = 'Travel Wet Wipes';
  // /cart.js line items do not include product tags, so tag membership is
  // resolved via the public /products/{handle}.js endpoint, once per unique
  // handle, cached for the life of the page. tagsPromiseCache dedupes
  // concurrent in-flight fetches; tagsByHandle holds the resolved array for
  // synchronous lookups (isGroupedItem) once Promise.all has settled.
  var tagsPromiseCache = {};
  var tagsByHandle = {};
  var lastFocusedElement = null;
  // Elements a real Tab key stop can land on. Filtered further, at trap time,
  // to only those actually visible/rendered (offsetParent check) so a fresh
  // AJAX re-render (e.g. fewer line items) is always reflected.
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function isOpen() {
    return drawer.getAttribute('aria-hidden') === 'false';
  }

  function announce(el, message) {
    if (!el) return;
    // Clear then set on the next frame so the same message announced twice
    // in a row (e.g. two identical subtotal updates) is still read by
    // screen readers that only react to a live-region mutation.
    el.textContent = '';
    window.requestAnimationFrame(function () {
      el.textContent = message;
    });
  }

  function escapeAttr(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function openDrawer(opener) {
    lastFocusedElement = opener || document.activeElement;
    drawer.classList.remove('pointer-events-none');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    overlay.classList.remove('pointer-events-none');
    overlay.classList.add('opacity-100');
    panel.classList.remove('pointer-events-none', 'ltr:translate-x-full', 'rtl:-translate-x-full');
    document.body.classList.add('overflow-hidden');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var wasOpen = isOpen();
    overlay.classList.remove('opacity-100');
    panel.classList.add('ltr:translate-x-full', 'rtl:-translate-x-full');
    document.body.classList.remove('overflow-hidden');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (wasOpen && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
    window.setTimeout(function () {
      drawer.classList.add('pointer-events-none');
      overlay.classList.add('pointer-events-none');
      panel.classList.add('pointer-events-none');
    }, 300);
  }

  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      renderCart().then(function () {
        openDrawer(toggle);
      });
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  // Continue Shopping never navigates - the drawer already sits on top of
  // whatever page the customer was on, so "continue shopping" just closes
  // it and returns focus there (same closeDrawer() the X button/overlay use).
  if (continueShoppingBtn) continueShoppingBtn.addEventListener('click', closeDrawer);

  // Escape-to-close + Tab focus trap. Single listener, bound once (this
  // script loads once per page - snippets/cart-drawer.liquid is rendered
  // directly from layout/theme.liquid, not inside a {% section %}, so it is
  // never re-initialized by the Shopify Theme Editor's section reload).
  // Guarded on isOpen() so it never interferes with the rest of the page.
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.key !== 'Tab') return;

    var focusable = Array.prototype.slice
      .call(panel.querySelectorAll(FOCUSABLE_SELECTOR))
      .filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var activeIndex = focusable.indexOf(document.activeElement);

    if (e.shiftKey) {
      if (activeIndex <= 0) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (activeIndex === -1 || activeIndex === focusable.length - 1) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  function moneyFormat(cents) {
    return window.Velo.formatMoney(cents);
  }

  function fetchCart() {
    return fetch(routeRoot + 'cart.js').then(function (r) { return r.json(); });
  }

  function renderLineItem(item) {
    var imgUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    var image = imgUrl ? '<img src="' + imgUrl + '" alt="' + (item.title || '') + '" class="w-full h-full object-cover" width="80" height="80">' : '';
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="text-xs text-text-secondary font-jost mt-0.5">' + item.variant_title + '</p>'
      : '';
    // No "X units total" helper line: "Pack of N" is never a real cart line.
    // Every Pack of N selection is submitted as the SINGLE variant with
    // quantity x N, so item.quantity IS already the physical unit count and
    // item.variant_title always reads "Single" - same convention as
    // snippets/cart-drawer.liquid's server-rendered initial markup.
    //
    // original_line_price/final_line_price are Shopify's own real AJAX Cart API
    // fields (already reflect any server-side discount, e.g. the Volume Pricing
    // discount function once deployed) - never recomputed/faked here. A Pack of
    // 2 line's saving therefore arrives as a real discount allocation on the
    // Single line, not from a Pack variant's compare_at_price. compare_at_price
    // is still honoured as a fallback for plain variants that carry one.
    // Customer-visible line-item properties (e.g. assets/pack-builder.js's
    // "Pack: Essential Pack" tag) - any underscore-prefixed key (Shopify's
    // own hidden-property convention, e.g. _pack_locked below) is a machine
    // flag, not customer-facing copy, and is never rendered here.
    var propertiesHtml = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        var value = item.properties[key];
        if (!key || key.charAt(0) === '_' || !value) return;
        propertiesHtml += '<p class="text-xs text-text-secondary font-jost mt-0.5">' + escapeAttr(key) + ': ' + escapeAttr(value) + '</p>';
      });
    }
    // A locked line's pack composition (which real design-variant lines make
    // up the pack) can only be safely re-split from the PDP - see
    // assets/pack-builder.js. Its own +/- stepper is disabled here rather
    // than removed so the current quantity stays visible; Remove still
    // works (removes the whole line, never a partial pack).
    var isLocked = !!(item.properties && item.properties._pack_locked === 'true');
    var stepperDisabledAttr = isLocked ? ' disabled' : '';
    var stepperDisabledClass = isLocked ? ' opacity-40 cursor-not-allowed' : '';
    var hasDiscount = item.original_line_price > item.final_line_price;
    var compareAtLineTotal = item.compare_at_price ? item.compare_at_price * item.quantity : 0;
    var hasCompareAt = !hasDiscount && compareAtLineTotal > item.final_line_price;
    var originalLineTotal = hasDiscount ? item.original_line_price : compareAtLineTotal;
    var showOriginal = hasDiscount || hasCompareAt;
    var originalPriceHtml = showOriginal
      ? '<span data-cart-line-original-price class="text-xs text-[#A0917F] font-jost line-through">' + moneyFormat(originalLineTotal) + '</span>'
      : '';
    var savingsHtml = showOriginal
      ? '<p data-cart-line-savings class="text-xs text-primary font-jost font-semibold mt-1">' + strings.youSave + ' ' + moneyFormat(originalLineTotal - item.final_line_price) + '</p>'
      : '';
    var titleAttr = escapeAttr(item.product_title);
    return (
      '<div class="flex gap-4" data-cart-line-item data-line-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden bg-[#F7F2EE]">' + image + '</a>' +
        '<div class="flex-1 min-w-0">' +
          '<a href="' + item.url + '" class="font-jost font-semibold text-sm text-text-primary line-clamp-2 hover:text-primary transition-colors">' + item.product_title + '</a>' +
          variantTitle +
          propertiesHtml +
          '<div class="flex items-center justify-between mt-2">' +
            '<div class="flex items-center border border-primary/30 rounded">' +
              '<button type="button" data-cart-qty-decrease class="w-7 h-7 flex items-center justify-center text-text-primary' + stepperDisabledClass + '"' + stepperDisabledAttr + ' aria-label="' + strings.decreaseQuantity + ' \u2013 ' + titleAttr + '">-</button>' +
              '<span data-cart-qty class="w-8 text-center text-sm font-jost" aria-label="' + strings.quantity + ': ' + item.quantity + '">' + item.quantity + '</span>' +
              '<button type="button" data-cart-qty-increase class="w-7 h-7 flex items-center justify-center text-text-primary' + stepperDisabledClass + '"' + stepperDisabledAttr + ' aria-label="' + strings.increaseQuantity + ' \u2013 ' + titleAttr + '">+</button>' +
            '</div>' +
            '<div class="flex items-baseline gap-1.5">' +
              originalPriceHtml +
              '<span data-cart-line-price class="text-sm font-semibold text-text-primary font-jost">' + moneyFormat(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          savingsHtml +
          '<button type="button" data-cart-remove class="text-xs text-text-secondary hover:text-primary underline mt-2 font-jost">' + strings.remove + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function getProductTags(handle) {
    if (tagsByHandle.hasOwnProperty(handle)) return Promise.resolve(tagsByHandle[handle]);
    if (!tagsPromiseCache[handle]) {
      tagsPromiseCache[handle] = fetch(routeRoot + 'products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) { return (product && product.tags) || []; })
        .catch(function () { return []; });
    }
    return tagsPromiseCache[handle].then(function (tags) {
      tagsByHandle[handle] = tags;
      return tags;
    });
  }

  // Only reliable once tagsByHandle[item.handle] has been populated by a
  // prior getProductTags() resolution (see updateDrawerHTML's Promise.all)
  // - /cart.js itself never carries tags.
  function isGroupedItem(item) {
    var tags = tagsByHandle[item.handle];
    return Array.isArray(tags) && tags.indexOf(GROUPED_PRODUCT_TAG) !== -1;
  }

  // Lines whose product carries GROUPED_PRODUCT_TAG (currently Travel Wet
  // Wipes' Wipe and Go / Fresh and Confident designs) are grouped here into
  // one merged customer-facing row instead of two separate design lines,
  // keyed by product_id (both designs are variants of the SAME product). A
  // solo tagged line (customer picked only one design) still routes through
  // the merged renderer/stepper below - see isGroupedItem check in
  // updateDrawerHTML - since its own quantity must also only ever move in
  // PACK_STEP increments, not single units.
  function groupCartItems(items) {
    var groups = [];
    var groupIndexByProductId = {};
    items.forEach(function (item) {
      var isGrouped = isGroupedItem(item);
      if (isGrouped && groupIndexByProductId.hasOwnProperty(item.product_id)) {
        groups[groupIndexByProductId[item.product_id]].push(item);
        return;
      }
      if (isGrouped) groupIndexByProductId[item.product_id] = groups.length;
      groups.push([item]);
    });
    return groups;
  }

  function sumQuantities(members) {
    return members.reduce(function (sum, m) { return sum + m.quantity; }, 0);
  }

  function renderMergedLineItem(members) {
    var first = members[0];
    var imgUrl = first.featured_image && first.featured_image.url ? first.featured_image.url : first.image;
    var image = imgUrl ? '<img src="' + imgUrl + '" alt="' + GROUPED_DISPLAY_TITLE + '" class="w-full h-full object-cover" width="80" height="80">' : '';
    var totalQuantity = sumQuantities(members);
    var totalOriginal = members.reduce(function (sum, m) { return sum + m.original_line_price; }, 0);
    // final_line_price does NOT reflect discounts applied by a Shopify
    // Function-based Automatic Discount (confirmed via real /cart.js: the
    // Wet Wipes Pack Pricing function leaves final_line_price equal to
    // original_line_price and instead reports the real discount via each
    // item's own total_discount field, real-tested 2026-08-23) - so the
    // real discounted total is derived from original_line_price minus
    // total_discount, never final_line_price, for a grouped row.
    var totalDiscount = members.reduce(function (sum, m) { return sum + (m.total_discount || 0); }, 0);
    var totalFinal = totalOriginal - totalDiscount;
    var hasDiscount = totalOriginal > totalFinal;
    var originalPriceHtml = hasDiscount
      ? '<span data-cart-line-original-price class="text-xs text-[#A0917F] font-jost line-through">' + moneyFormat(totalOriginal) + '</span>'
      : '';
    var savingsHtml = hasDiscount
      ? '<p data-cart-line-savings class="text-xs text-primary font-jost font-semibold mt-1">' + strings.youSave + ' ' + moneyFormat(totalOriginal - totalFinal) + '</p>'
      : '';
    var titleAttr = escapeAttr(GROUPED_DISPLAY_TITLE);
    var groupKeysAttr = escapeAttr(members.map(function (m) { return m.key; }).join(','));
    var groupQuantitiesAttr = escapeAttr(members.map(function (m) { return m.quantity; }).join(','));
    // Minimum grouped quantity is PACK_STEP - decrease is disabled (not just
    // clamped in the click handler) once the group is at its floor, leaving
    // Remove as the only way to clear the group entirely.
    var canDecrease = totalQuantity > PACK_STEP;
    var decreaseDisabledAttr = canDecrease ? '' : ' disabled';
    var decreaseDisabledClass = canDecrease ? '' : ' opacity-40 cursor-not-allowed';
    return (
      '<div class="flex gap-4" data-cart-line-item data-group-keys="' + groupKeysAttr + '" data-group-quantities="' + groupQuantitiesAttr + '">' +
        '<a href="' + first.url + '" class="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden bg-[#F7F2EE]">' + image + '</a>' +
        '<div class="flex-1 min-w-0">' +
          '<a href="' + first.url + '" class="font-jost font-semibold text-sm text-text-primary line-clamp-2 hover:text-primary transition-colors">' + GROUPED_DISPLAY_TITLE + '</a>' +
          '<div class="flex items-center justify-between mt-2">' +
            '<div class="flex items-center border border-primary/30 rounded">' +
              '<button type="button" data-cart-qty-decrease class="w-7 h-7 flex items-center justify-center text-text-primary' + decreaseDisabledClass + '"' + decreaseDisabledAttr + ' aria-label="' + strings.decreaseQuantity + ' \u2013 ' + titleAttr + '">-</button>' +
              '<span data-cart-qty class="w-8 text-center text-sm font-jost" aria-label="' + strings.quantity + ': ' + totalQuantity + '">' + totalQuantity + '</span>' +
              '<button type="button" data-cart-qty-increase class="w-7 h-7 flex items-center justify-center text-text-primary" aria-label="' + strings.increaseQuantity + ' \u2013 ' + titleAttr + '">+</button>' +
            '</div>' +
            '<div class="flex items-baseline gap-1.5">' +
              originalPriceHtml +
              '<span data-cart-line-price class="text-sm font-semibold text-text-primary font-jost">' + moneyFormat(totalFinal) + '</span>' +
            '</div>' +
          '</div>' +
          savingsHtml +
          '<button type="button" data-cart-remove class="text-xs text-text-secondary hover:text-primary underline mt-2 font-jost">' + strings.remove + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  // Grouping decisions depend on each item's product tags, which /cart.js
  // never includes - so tags for every unique handle in the cart are
  // resolved (via getProductTags, cached) before the items are grouped and
  // rendered. See getProductTags/isGroupedItem above.
  function updateDrawerHTML(cart) {
    if (!itemsWrap) return;
    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '<p data-cart-empty class="text-text-secondary font-jost text-center py-12">' + strings.empty + '</p>';
      finishDrawerUpdate(cart);
      return;
    }
    var handles = [];
    cart.items.forEach(function (item) {
      if (handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });
    Promise.all(handles.map(getProductTags)).then(function () {
      itemsWrap.innerHTML = groupCartItems(cart.items).map(function (members) {
        return isGroupedItem(members[0]) ? renderMergedLineItem(members) : renderLineItem(members[0]);
      }).join('');
      finishDrawerUpdate(cart);
    });
  }

  function finishDrawerUpdate(cart) {
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
    // cart.original_total_price/cart.total_price are Shopify's own real AJAX
    // Cart API fields (same convention as line items above) - never faked.
    var hasSubtotalDiscount = cart.original_total_price > cart.total_price;
    if (subtotalOriginalEl) {
      subtotalOriginalEl.textContent = moneyFormat(cart.original_total_price);
      subtotalOriginalEl.classList.toggle('hidden', !hasSubtotalDiscount);
    }
    if (subtotalSavingsEl) subtotalSavingsEl.classList.toggle('hidden', !hasSubtotalDiscount);
    if (subtotalSavingsAmountEl && hasSubtotalDiscount) {
      subtotalSavingsAmountEl.textContent = moneyFormat(cart.original_total_price - cart.total_price);
    }
    if (checkoutLink) {
      checkoutLink.classList.toggle('opacity-50', cart.item_count === 0);
      checkoutLink.classList.toggle('pointer-events-none', cart.item_count === 0);
    }
    bindLineItemEvents();
  }

  // Every quantity/remove click on a line is a real network round-trip
  // (/cart/update.js or /cart/change.js) with NO optimistic DOM update, so
  // without an immediate visual + interaction change a slow connection reads
  // as the button having done nothing ("hanging"), and a second click before
  // the first request settles fires a redundant, racy second request against
  // stale in-memory `members`/`quantity` data. runBusy() disables every
  // control on that one line and dims it the instant a click is handled,
  // re-enabling it only if the request itself fails - a successful request
  // always replaces the whole line (and its listeners) via the normal
  // fetchCart -> updateDrawerHTML -> bindLineItemEvents render cycle, so
  // there is nothing to re-enable on the success path.
  function setLineBusy(line, busy) {
    line.classList.toggle('opacity-50', busy);
    line.classList.toggle('pointer-events-none', busy);
    line.querySelectorAll('button').forEach(function (btn) { btn.disabled = busy; });
  }

  function runBusy(line, action) {
    if (line.dataset.busy === 'true') return;
    line.dataset.busy = 'true';
    setLineBusy(line, true);
    action().catch(function () {
      // action() itself already logs/announces the error; here we only
      // restore interactivity on the line that failed to update.
      line.dataset.busy = '';
      setLineBusy(line, false);
    });
  }

  function bindLineItemEvents() {
    itemsWrap.querySelectorAll('[data-cart-line-item]').forEach(function (line) {
      var groupKeysAttr = line.getAttribute('data-group-keys');
      var decreaseBtn = line.querySelector('[data-cart-qty-decrease]');
      var increaseBtn = line.querySelector('[data-cart-qty-increase]');
      var removeBtn = line.querySelector('[data-cart-remove]');

      if (groupKeysAttr) {
        var keys = groupKeysAttr.split(',');
        var quantities = line.getAttribute('data-group-quantities').split(',').map(function (n) {
          return parseInt(n, 10) || 0;
        });
        var members = keys.map(function (key, i) { return { key: key, quantity: quantities[i] }; });

        if (decreaseBtn) {
          decreaseBtn.addEventListener('click', function () {
            var newTotal = Math.max(PACK_STEP, sumQuantities(members) - PACK_STEP);
            runBusy(line, function () { return changeGroupQuantity(members, newTotal); });
          });
        }
        if (increaseBtn) {
          increaseBtn.addEventListener('click', function () {
            runBusy(line, function () { return changeGroupQuantity(members, sumQuantities(members) + PACK_STEP); });
          });
        }
        if (removeBtn) {
          removeBtn.addEventListener('click', function () {
            runBusy(line, function () { return changeGroupQuantity(members, 0); });
          });
        }
        return;
      }

      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('[data-cart-qty]');

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          var newQty = Math.max(0, parseInt(qtyEl.textContent, 10) - 1);
          runBusy(line, function () { return changeLine(key, newQty); });
        });
      }
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          var newQty = parseInt(qtyEl.textContent, 10) + 1;
          runBusy(line, function () { return changeLine(key, newQty); });
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          runBusy(line, function () { return changeLine(key, 0); });
        });
      }
    });
  }

  function renderCart() {
    return fetchCart().then(function (cart) {
      updateDrawerHTML(cart);
      window.Velo.updateCartUI(cart);
      return cart;
    });
  }

  // Splits newTotal across a locked pack's member lines proportionally to
  // their current quantities (largest-remainder rounding so the parts
  // always sum to exactly newTotal), preserving the customer's chosen
  // design mix as the combined pack quantity moves in PACK_STEP increments.
  function redistribute(members, newTotal) {
    var oldTotal = sumQuantities(members);
    if (oldTotal <= 0) {
      return members.map(function (_, i) { return i === 0 ? newTotal : 0; });
    }
    var raw = members.map(function (m) { return (m.quantity / oldTotal) * newTotal; });
    var floors = raw.map(Math.floor);
    var used = floors.reduce(function (sum, v) { return sum + v; }, 0);
    var remainder = newTotal - used;
    var order = raw
      .map(function (v, i) { return { i: i, frac: v - floors[i] }; })
      .sort(function (a, b) { return b.frac - a.frac; });
    var result = floors.slice();
    for (var k = 0; k < remainder; k++) {
      result[order[k % order.length].i] += 1;
    }
    return result;
  }

  function changeGroupQuantity(members, newTotal) {
    var clampedTotal = Math.max(0, newTotal);
    var newQuantities = redistribute(members, clampedTotal);
    var updates = {};
    members.forEach(function (m, i) { updates[m.key] = newQuantities[i]; });
    return updateCartLines(updates, clampedTotal === 0);
  }

  // Atomic multi-line update (POST /cart/update.js) - a locked pack's
  // combined quantity moves directly from one valid multiple-of-PACK_STEP
  // total to another in a SINGLE request, so it never passes through an
  // invalid intermediate state the way two sequential /cart/change.js calls
  // would (this is what previously blocked Remove/quantity changes against
  // extensions/wet-wipes-pack-validation).
  function updateCartLines(updates, isRemoval) {
    return fetch(routeRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateDrawerHTML(cart);
        window.Velo.updateCartUI(cart);
        var template = isRemoval ? strings.itemRemoved : strings.quantityUpdated;
        announce(livePoliteEl, template.replace('%SUBTOTAL%', moneyFormat(cart.total_price)));
      })
      .catch(function (err) {
        console.error('Cart update failed', err);
        announce(liveAssertiveEl, strings.errorGeneric);
        throw err;
      });
  }

  function changeLine(key, quantity) {
    return fetch(routeRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateDrawerHTML(cart);
        window.Velo.updateCartUI(cart);
        var template = quantity === 0 ? strings.itemRemoved : strings.quantityUpdated;
        announce(livePoliteEl, template.replace('%SUBTOTAL%', moneyFormat(cart.total_price)));
      })
      .catch(function (err) {
        console.error('Cart update failed', err);
        announce(liveAssertiveEl, strings.errorGeneric);
        throw err;
      });
  }

  function addToCart(form) {
    // Multi-item forms (assets/pack-builder.js's "build your pack" mix,
    // which always resolves to 2 REAL variants since the native Shopify
    // Bundle/variant-fixed-bundle mechanism was removed) write a JSON
    // items array into this hidden field right before submit - takes
    // priority over the plain id/quantity FormData flatten below, which
    // every other (single-variant) purchase form still uses unchanged.
    var itemsField = form.querySelector('[data-cart-items-json]');
    var body = null;
    if (itemsField && itemsField.value) {
      try {
        var items = JSON.parse(itemsField.value);
        if (Array.isArray(items) && items.length) body = { items: items };
      } catch (e) {
        body = null;
      }
    }
    if (!body) {
      var formData = new FormData(form);
      body = {};
      formData.forEach(function (value, key) {
        body[key] = value;
      });
    }
    return fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-cart-form]')) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[data-add-to-cart]');
    if (submitBtn) submitBtn.disabled = true;
    addToCart(form)
      .then(function () {
        return renderCart();
      })
      .then(function () {
        openDrawer(submitBtn);
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        announce(liveAssertiveEl, strings.errorGeneric);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
})();
